import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API()+'klienci/karty/';

export default {

    getKarty() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getKartyByNrKarty(nrKarty){
        return axios({
            method: 'get',
            url: URL+'search?nazwiskoOrNumerKarty='+nrKarty
        });
    },

    getKartyPageable(page,size,nazwiskoOrNr=null,status='',trasa=''){
        return axios({
            method: 'get',
            url: (Boolean(nazwiskoOrNr))?URL + 'search?page='+page+'&size='+size+'&nazwiskoOrNumerKarty='+nazwiskoOrNr+'&status='+status+'&idTr='+trasa
                :
                URL + 'search?page='+page+'&size='+size+'&status='+status+'&idTr='+trasa

        });
    },

    szukajKart(nazwiskoOrNr=null){
        return axios({
            method: 'get',
            url: Boolean(nazwiskoOrNr)? URL + 'search?page=0&size=1000&nazwiskoOrNumerKarty='+nazwiskoOrNr
                :
                URL + 'search?page=0&size=99999'
            ,
        });
    },

    getKarta(id){
        return axios({
            method: 'get',
            url: URL + id,
        });
    },

    addKarta(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editKarta(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteKarta(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

}


// WEBPACK FOOTER //
// ./src/modules/klienciConfig/karty/KartyService.js